import { IvaTypeEnums } from 'src/app/enum/iva-type-enums';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { InvoiceEnums } from './../../enum/invoice-enums';
import { CurrencyExchangeModel } from '../archive/currency-exchage.model';
import { EnterpriseModel } from '../management/enterprise.model';

export class InvoiceModel {
  invoiceId: number = 0;
  branchId: number = 0;
  enterpriseId: number = 0;
  enterprise: EnterpriseModel = new EnterpriseModel();
  enterpriseSwSelfRetainer: boolean = false;
  enterpriseSwIcaSelfRetainer: boolean = false;  // Se llena en el backend
  bussinessDocumentsTypeId: number = 0;
  bussinessDocumentsTypeIsRental: boolean = true;
  bussinessDocumentsResolutionId: number = 0;  // Se llena en el backend
  consecutive: number = 0; // Se llena en el backend
  conceptTypeDIANId: number = 0;
  invoiceOperationId: number = InvoiceEnums.credito;
  dateInvoice: Date = new Date;
  rentalPeriodId: number = 0; // Se llena en el backend
  dateExpiration: Date = new Date;
  invoiceWalletTypeId: number = InvoiceEnums.corriente;
  clientId: number = 0;
  costCenterId: number | null = null;
  costCenter: CostCenterModel | null = null;
  ivaTypeId: number = IvaTypeEnums.pleno;
  administrationRate: number = 0;
  incidentalRate: number = 0;
  utilityRate: number = 0;
  zoneId: number = 0;
  sellerId: number = 0;
  invoiceStateId: number = InvoiceEnums.abierta;
  swBlock: boolean = false;
  swManual: boolean = false; //Se llena en el backend
  swCopied: boolean = false;
  invoiceOriginId: number | null = null;
  invoiceOriginConsecutive: number | null = null;
  invoicingCutoffId: number | null = null;
  movementId: number | null = null;
  accountingInterfaceId: number | null = null;
  electronicInvoiceInterfaceId: number | null = null;
  observation: string | null = null;
  purchaseOrder: string | null = null;
  approvalNumber: string | null = null;
  remission: string | null = null;
  cufe: string | null = null; //Se llena en el backend
  debitNotesValue: number = 0;
  creditNotesValue: number = 0;
  paymentValue: number = 0;
  residueValue: number = 0;
  subtotalValue: number = 0;
  discountValue: number = 0;
  ivaValue: number = 0;
  totalValue: number = 0;
  reteIvaRate: number = 0;
  reteIvaValue: number = 0;
  reteFuenteValue: number = 0;
  reteIcaValue: number = 0;
  valueToPay: number = 0;
  dateInvoicePdf: Date | null = null;
  dateInvoiceEmail: Date | null = null;
  dateInvoiceResend: Date | null = null;
  statusAcuse: number = 0;
  responseAcuse: string | null = null;
  responseEmailAcuse: string | null = null;
  validationDian: number | null = null;
  dateValidationDian: Date | null = null;
  statusDianCode: number | null = null;
  statusDianDescription: string | null = null;
  technologicalProviderMessageCode: string | null = null;
  technologicalProviderMessageDescription: string | null = null;
  xmlName: string | null = null;
  dateInvoiceContingency: Date | null = null;
  consecutiveInvoiceContingency: number | null = null;
  typeCodeInvoiceContingency: string | null = null;
  clientStatusCode: string | null = null;
  swAttachments: boolean = false;
  conceptPaymentMethodId: number = 0;
  currencyExchangeId: number | null = null;
  currencyExchange: CurrencyExchangeModel | null = null;
  settlementType: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //Campos para anular cuenta de cobros
  conceptAnnulId: number | null = null;
  dateAnnul: Date | null = null;
  observationAnnul: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}
